var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "actions-collapsed-list" },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-function exit-collapsed-list",
          attrs: { disabled: _vm.disabled },
          on: { click: _vm.collapseActions }
        },
        [
          _c("i", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.right.hover",
                value: _vm.$t("CANCEL"),
                expression: "$t('CANCEL')",
                modifiers: { right: true, hover: true }
              }
            ],
            staticClass: "glyphicon glyphicon-chevron-left",
            attrs: { "aria-hidden": "true" }
          })
        ]
      ),
      _vm._v(" "),
      _vm.createAccess
        ? _c("div", { staticClass: "action-icon" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-list-function",
                attrs: {
                  href: _vm.href,
                  disabled: _vm.currentPublisher.isSelf
                },
                on: { click: _vm.showForm }
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.right.hover",
                      value: _vm.$t("PUBLISHERS_ACTIONS_I_EDIT_ALT"),
                      expression: "$t('PUBLISHERS_ACTIONS_I_EDIT_ALT')",
                      modifiers: { right: true, hover: true }
                    }
                  ],
                  staticClass: "typcn typcn-edit",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "PUBLISHERS_ACTIONS_I_EDIT_ALT",
                      expression: "'PUBLISHERS_ACTIONS_I_EDIT_ALT'"
                    }
                  ],
                  staticClass: "hint-text-mobile"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-list-function",
            attrs: { disabled: _vm.disabled },
            on: { click: _vm.showInvites }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.right.hover",
                  value: _vm.$t("MANAGE_USER_INVITES"),
                  expression: "$t('MANAGE_USER_INVITES')",
                  modifiers: { right: true, hover: true }
                }
              ],
              staticClass: "fa m-t-4 fa-user-plus",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "MANAGE_USER_INVITES",
                  expression: "'MANAGE_USER_INVITES'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-list-function",
            attrs: { disabled: _vm.disabled },
            on: { click: _vm.viewReport }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.left.hover",
                  value: _vm.$t("PUBLISHERS_ACTIONS_REPORTING"),
                  expression: "$t('PUBLISHERS_ACTIONS_REPORTING')",
                  modifiers: { left: true, hover: true }
                }
              ],
              staticClass: "typcn typcn-chart-pie"
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "PUBLISHERS_ACTIONS_REPORTING",
                  expression: "'PUBLISHERS_ACTIONS_REPORTING'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.currentPublisher.enabled
        ? _c(
            "div",
            { staticClass: "action-icon", attrs: { disabled: _vm.disabled } },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-list-function",
                  attrs: {
                    disabled: _vm.disabled || _vm.currentPublisher.isSelf
                  },
                  on: { click: _vm.confirmPause }
                },
                [
                  _c("i", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.right.hover",
                        value: _vm.$t("PUBLISHERS_ACTIONS_PAUSE"),
                        expression: "$t('PUBLISHERS_ACTIONS_PAUSE')",
                        modifiers: { right: true, hover: true }
                      }
                    ],
                    staticClass: "typcn typcn-media-pause"
                  }),
                  _vm._v(" "),
                  _c("span", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "PUBLISHERS_ACTIONS_PAUSE",
                        expression: "'PUBLISHERS_ACTIONS_PAUSE'"
                      }
                    ],
                    staticClass: "hint-text-mobile"
                  })
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.currentPublisher.enabled
        ? _c("div", { staticClass: "action-icon" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-list-function",
                attrs: {
                  disabled: _vm.disabled || _vm.currentPublisher.isSelf
                },
                on: { click: _vm.setStatus }
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.right.hover",
                      value: _vm.$t("PUBLISHERS_ACTIONS_ENABLE"),
                      expression: "$t('PUBLISHERS_ACTIONS_ENABLE')",
                      modifiers: { right: true, hover: true }
                    }
                  ],
                  staticClass: "typcn typcn-media-play"
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "PUBLISHERS_ACTIONS_ENABLE",
                      expression: "'PUBLISHERS_ACTIONS_ENABLE'"
                    }
                  ],
                  staticClass: "hint-text-mobile"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-list-function",
            attrs: { disabled: _vm.disabled || _vm.currentPublisher.isSelf },
            on: { click: _vm.confirmDelete }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.right.hover",
                  value: _vm.$t("PUBLISHERS_ACTIONS_DELETE"),
                  expression: "$t('PUBLISHERS_ACTIONS_DELETE')",
                  modifiers: { right: true, hover: true }
                }
              ],
              staticClass: "typcn typcn-trash",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "PUBLISHERS_ACTIONS_DELETE",
                  expression: "'PUBLISHERS_ACTIONS_DELETE'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-list-function",
            attrs: { disabled: _vm.disabled },
            on: { click: _vm.showPublisherReferences }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom.hover",
                  value: _vm.$t("SHOW_REFERENCES"),
                  expression: "$t('SHOW_REFERENCES')",
                  modifiers: { bottom: true, hover: true }
                }
              ],
              staticClass: "typcn typcn-flow-children",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "SHOW_REFERENCES",
                  expression: "'SHOW_REFERENCES'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("ChangeLogObjectButtonAction", {
        attrs: {
          "is-disabled": _vm.disabled,
          "object-id": _vm.currentPublisher.id,
          "object-name": _vm.currentPublisher.name,
          "object-type": "publisher"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }